module.exports = fox._r("images/logotype.png", __webpack_public_path__ + "_/_/_/root/images/logotype.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/logotype.png
// module id = 6
// module chunks = 4